import React from 'react';
import TranslatedComponent from '../../utils/TranslatedComponent';

export class DisneyStoreLogo extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var classNames = ['logo', 'disneyStoreLogo'];
    if (this.props.isPrimary) {
      classNames.push('primaryLogo');
    }
    return (
      <svg
        className={classNames.join(' ')}
        aria-labelledby='disneyStore-logo-title'
        role='img'
        version='1.1'
        id='Layer_1'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        x='0px'
        y='0px'
        viewBox='0 0 1308 434'
        xmlSpace='preserve'
        fill='#ffffff'
      >
        <g>
          <g>
            <g>
              <path
                d='M868.3,265.8c-2.3-1.2-4-3.8-4-7.3c0-4.7,3.7-8.5,8.5-8.5c1.6,0,3.3,0.5,4.5,1.2c8.9,5.9,18.1,8.9,26.4,8.9
				c9,0,14.3-3.8,14.3-9.9v-0.3c0-7.1-9.7-9.6-20.5-12.9c-13.6-3.8-28.7-9.4-28.7-27v-0.3c0-17.4,14.4-28,32.7-28
				c9.7,0,19.8,2.8,28.9,7.5c3,1.6,5,4.3,5,8c0,4.9-4,8.5-8.7,8.5c-1.7,0-2.8-0.3-4.2-1c-7.5-3.8-15.1-6.3-21.6-6.3
				c-8.2,0-12.9,3.8-12.9,9.2v0.3c0,6.6,9.9,9.4,20.7,12.9c13.4,4.2,28.5,10.3,28.5,26.8v0.3c0,19.3-15,28.9-34.1,28.9
				C891.6,276.7,878.9,273.1,868.3,265.8z'
              />
              <path
                d='M959.8,249.6v-48.3h-3.5c-5,0-9-4-9-9c0-5,4-9,9-9h3.5v-15.7c0-5.7,4.7-10.4,10.4-10.4
				c5.9,0,10.6,4.7,10.6,10.4v15.7h16.5c5,0,9,4,9,9c0,5-4,9-9,9h-16.5v45c0,8.2,4.2,11.5,11.3,11.5c2.4,0,4.5-0.5,5.2-0.5
				c4.7,0,8.9,3.8,8.9,8.7c0,3.8-2.6,7-5.6,8.2c-4.5,1.6-8.9,2.4-14.4,2.4C970.7,276.5,959.8,269.8,959.8,249.6z'
              />
              <path
                d='M1017.3,229.6v-0.3c0-26.3,20.9-48,49-48s48.9,21.4,48.9,47.7v0.3c0,26.1-20.9,47.8-49.2,47.8
				C1038,277.1,1017.3,255.7,1017.3,229.6z M1094.2,229.6v-0.3c0-16.2-11.6-29.6-28.2-29.6c-16.9,0-27.7,13.2-27.7,29.2v0.3
				c0,16,11.7,29.6,28,29.6C1083.4,258.8,1094.2,245.4,1094.2,229.6z'
              />
              <path
                d='M1134.9,192.7c0-5.7,4.5-10.6,10.4-10.6c5.7,0,10.6,4.7,10.6,10.6v9.4c4.9-11.5,13.9-20.2,23.1-20.2
				c6.6,0,10.4,4.5,10.4,10.4c0,5.6-3.7,9.2-8.3,10.1c-15,2.6-25.2,14.1-25.2,35.8v27.1c0,5.7-4.7,10.4-10.6,10.4
				c-5.7,0-10.4-4.5-10.4-10.4V192.7z'
              />
              <path
                d='M1197,229.4v-0.3c0-26.3,18.6-47.8,44.9-47.8c29.2,0,43.7,24,43.7,45.2c0,5.9-4.5,10.1-9.9,10.1H1218
				c2.3,15,12.9,23.3,26.4,23.3c8.9,0,15.8-3,21.7-8c1-0.9,3-1.9,5.4-1.9c4.7,0,8.3,3.8,8.3,8.5c0,2.6-1.2,4.9-2.8,6.3
				c-8.3,7.5-18.8,12.3-33,12.3C1217.5,277.1,1197,257.8,1197,229.4z M1265,222.6c-1.4-13.6-9.4-24.2-23.3-24.2
				c-12.9,0-21.9,9.9-23.8,24.2H1265z'
              />
            </g>
          </g>
          <g>
            <path
              d='M239.1,72.3c0,0-104.7-58-193.1-30.1c0,0-5.5-0.2-10.7,6.9c-5.2,7.1-9.9,12-7.3,17.4c2.6,5.5,16.1,8.2,28,4.9
			c0,0,5.5-3.5-1.2-5.9c-6.7-2.5-10.3-3-10.3-3s-3.6-1,0.1-2.7c3.7-1.7,43.9-13.2,114.1,7C229,87,322.9,146.9,318.4,206.2
			c-4.4,59.3-97.4,59.3-97.4,59.3s-19.2,0.3-44.7-5.2c0-19.4,0-52.1,0.9-72.5c22.5,1.4,69.3,5.7,75.5,16.9c0,0,2.9,2.8-6.6,8
			c-7.2,3.9-13.3,5.5-7,8.9c0,0,9.2,5.7,14.6,4.1c5.5-1.7,20.6-6.7,22.4-22.5c1.8-15.8-17.2-31.8-44.5-37.1
			c-21.4-4.2-32.8-6.4-52.4-6.1c0.4-17.7-1.5-39.7-5.2-45c-4.8-6.9-10-16.2-14.3-6.3c-3.9,8.9-7.4,27.7-9.1,53.3
			c-30.1,3.9-63.5,15.7-73.6,27.8c-11.3,13.5-0.6,24.9,0.2,26.1c0.8,1.3,21.6,33.4,68.4,56c0.5,8.5,1.8,17.8,5.1,23
			c6.9,11.1,20.3,3.8,22.2,2c1.3-1.3,2.5-4.8,3.1-13.2c20.9,5.9,58.8,12.9,100,1.7c62.1-16.8,71.9-54.8,74.3-77.5
			C352.8,185.2,337.5,125.4,239.1,72.3z M177.3,186.9C177.3,186.9,177.3,186.9,177.3,186.9C181.1,186.8,180,186.8,177.3,186.9z
			 M83.4,209.3c0,0-6.6-7.5,3.5-11.7c9.2-3.9,28.6-9,62.9-10.3c-0.3,10.5-1.3,32.6-4,64C124,243,101.3,230,83.4,209.3z'
            />
            <path
              d='M398.6,146.4c25.2-7.7,49.7-31.2,50.4-50.7c0.8-19.5-21-19.9-21-19.9c-0.2,0-0.3,0-0.4,0
			c-3.4-12.3-26.2-11.2-26.2-11.2c-46.1,2.5-62.2,34-64.5,42.4c-2,7.3-1.5,18.3,7.3,26.3c-2.9,6.9-0.9,10.1-0.2,12
			c0.8,2.3,4.7,9.4,9.2,9.1c3.2-0.2,5.7-2.3,9.7-9.3C372,149.2,382.9,151.1,398.6,146.4z M430.9,104.7
			c-13.5,25.8-42.3,26.1-58.5,22.8c10.7-15.5,33.9-34.3,48.4-36.3C437.5,89,430.9,104.7,430.9,104.7z M357.1,102
			c6.6-9.8,15.8-14,27.2-14.8c-14.6,9.2-24.9,21.8-30.5,30C351.8,114,352.1,109.5,357.1,102z'
            />
            <path
              d='M387.1,230.8c0,0-0.5-38.1-0.9-46.1c-0.4-8-3-11.9-5.4-15.4c-2.4-3.5-5.7-8.1-11.5-3.3
			c-5.8,4.8-7.2,36.3-8.6,61.4c-1.4,25.2-0.5,41.1,2.5,45.5c3.1,4.4,14.8,6.5,20.2,2.6c5.3-3.9,3.8-41.2,3.8-41.2V230.8z'
            />
            <path
              d='M513.5,173.3c-7.9-9.3-52.6-9-52.6-9c-16.6,0.9-54.9,6.8-60.1,23.4c-5.2,16.6-1,22.4-1,22.4
			c4.5,8.5,36.6,9,45.4,9.7c8.8,0.7,32.1,4.4,40.1,9.1c8,4.8,2.4,11,2.4,11c-7.8,11.4-50.9,12.1-50.9,12.1s-15.4-0.2-19.4-3.5
			c-4-3.3-5.2-6-0.8-11.1c4.4-5.1,16,0.9,16,0.9s9.3,6.9,22,7.4c12.7,0.6,21.9-3.9,22.5-8.2c0.6-4.3-10.9-9-10.9-9
			c-37.7-11.7-53.2-2.9-53.2-2.9c-21,12.6-6.1,30.2-6.1,30.2c32.7,36.8,85.5,14.9,91.6,9.9c6-5.1,8.7-10.4,9.3-25.1
			c0.6-14.7-5.5-21.5-5.5-21.5c-10.5-13.7-41.1-14.6-49.5-15.3c-8.4-0.7-25.7-3.3-30-4.3c-4.3-1-1.2-4.1-1.2-4.1
			c5.5-4.1,46.7-6.4,68.5-7l12.3-1.2c7.9-1,9.2-5.6,10.7-9C514.6,174.9,513.5,173.3,513.5,173.3z'
            />
            <path
              d='M579.9,151.9c0,0-4.7-2.4-6.2,2.5c-1.5,5,0.2,10,0.2,10c11.2,42.3,13.2,66.8,13.2,66.8s0.5,7.2-0.8,7.8
			c-1.3,0.7-2.4-0.4-2.4-0.4c-1.1-0.3-14.1-23.2-14.1-23.2l-2.3-4.3c-14.5-24.5-22.9-32.9-22.9-32.9c-2.2-2-7.5-7.5-14.5-0.2
			c-7,7.3-12.7,31.1-15.4,53.7c-2.7,22.6-1.5,35.6,1.8,41.1c3.2,5.6,10.2,7.6,16.2,3c6-4.6,6-34.4,7.3-49.6
			c1.4-15.1,2.6-12.5,2.6-12.5c1.4-0.2,8,14.1,8,14.1s17.5,37.9,28.9,44c11.4,6,21.2-2.8,25-11.1c3.9-8.3,10.8-36.2,2.4-67.5
			C598.7,161.9,579.9,151.9,579.9,151.9z'
            />
            <path
              d='M697.3,263c1.5-5.3-3.6-12.3-8.4-13.6c-4.2-1.2-39.5,4.4-43.8,5.4c-4.3,1-2.3-3.1-2.3-3.1l6-18
			c0,0,33.3-0.3,38-1c4.7-0.8,5-3.9,5-3.9s0.6-5.2,0.5-10.2c-0.1-5-4.4-4.9-4.4-4.9c-12.9-1.5-30.4-0.4-30.4-0.4l4.6-14.2l2.2-0.1
			c16.5,0.6,40.2-1.8,46.9-3.4c6.7-1.6,3.2-8.4,3.2-8.4c-8-17-17.7-16.2-17.7-16.2c-28.4-1.8-68.5,4.8-73,6.5
			c-4.4,1.7-4.1,5.1,1.3,11.8c5.3,6.7,15.3,7,15.3,7l-8.9,17.3c-6.9,0.4-9.3,2.5-9.3,2.5c-4.2,4.1,0.8,17,0.8,17s-1.9,3.8-3.9,9.7
			c-2,5.8-8.3,16.2-0.4,31.8c7.9,15.6,20.1,14.8,20.1,14.8C660.5,290.4,695.2,270.6,697.3,263z'
            />
            <path
              d='M808,184.8c-11.1-8.2-20.9-0.6-20.9-0.6c-19.5,10.1-44,40.1-57.4,57.8c-1.9-12.8,7.1-28.7,7.1-28.7l2.1-3.7
			c10.7-18.1,12.4-20,14.6-24.6c2.2-4.7,3.4-15.1,1.1-16.1c-2.2-0.9-6,2.4-6,2.4c-32.1,26.9-37.3,57.9-37.3,57.9
			c-3.3,16-0.7,27.6,3.8,35.7c-18.3,37.9-25.1,74.4-25.1,88.6c0.1,15.3,11.8,25.3,18,27.9c6.3,2.7,7.4-5.1,7.4-5.1
			c6.4-38.8,16-64.7,27.3-90.6c32,8.7,58.6-25,66.9-37.7c9.4-14.4,9.4-34,9.4-34C819.3,212.1,819.1,193.1,808,184.8z M785.1,246.9
			c-3.9,3.4-16.2,10-29,11c12.9-23.2,28.4-40.3,36.9-49.3c10.3-10.8,11.4-0.6,11.4-0.6C806.1,227.4,791.4,241.5,785.1,246.9z'
            />
          </g>
        </g>
      </svg>
    );
  }
}

TranslatedComponent(DisneyStoreLogo);
export default DisneyStoreLogo;



// WEBPACK FOOTER //
// ./client/src/components/logos/DisneyStoreLogo.jsx